<script>
  import { AppModal } from '@/components/_shared'

  export default {
    name: 'app',

    components: {
      AppModal
    },

    metaInfo: {
      titleTemplate: (titleChunk => {
        return titleChunk ? `${titleChunk} - Hive` : 'Hive'
      })
    },

    mounted () {
      const splashScreen = document.getElementById('splash')

      if (splashScreen) {
        splashScreen.style.opacity = '0'
        setTimeout(() => {
          splashScreen && splashScreen.parentNode.removeChild(splashScreen)
        }, 600)
      }
    }
  }
</script>

<template>
  <div id="app">
    <router-view :key="$router.fullPath"/>
    <app-modal/>
    <notifications position="bottom right"/>
    <vue-progress-bar/>
  </div>
</template>
